import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Megaphone } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-whats-new/admin`;

export const AnnounceUpdateCard = ({ token }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const h = { headers: { Authorization: `Bearer ${token}` } };
  const load = () => axios.get(`${API}/status`, h).then(r => setD(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);
  const send = async () => {
    if (!window.confirm(`Email the "What's new" update to ${d.tier1} Tier 1 and ${d.tier2} Tier 2 subscribers now? This can only be sent once.`)) return;
    setBusy(true);
    try { const r = await axios.post(`${API}/announce`, {}, h); toast.success(r.data.message); load(); }
    catch (e) { toast.error(e.response?.data?.detail?.toString() || 'Send failed'); }
    setBusy(false);
  };
  if (!d) return null;
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-xl p-5 flex flex-wrap items-center justify-between gap-3 mb-6" data-testid="announce-update-card">
      <div>
        <p className="text-white font-semibold flex items-center gap-2"><Megaphone className="w-4 h-4 text-emerald-400" /> Subscriber update email</p>
        <p className="text-xs text-slate-400" data-testid="announce-counts">{d.tier1} Tier 1 · {d.tier2} Tier 2 subscribers · tailored "What's new" per tier</p>
      </div>
      {d.sent
        ? <p className="text-xs text-emerald-300" data-testid="announce-sent">Sent {d.sent.at.slice(0, 10)} to {d.sent.sent} subscriber(s){d.sent.failed ? `, ${d.sent.failed} failed` : ''}</p>
        : <button onClick={send} disabled={busy || !(d.tier1 + d.tier2)} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-40 text-white rounded text-sm font-semibold" data-testid="announce-send">{busy ? 'Sending…' : 'Email Tier 1 & Tier 2 subscribers'}</button>}
    </div>
  );
};
